import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WeiboOutlinedSvg from "@ant-design/icons-svg/es/asn/WeiboOutlined";
import AntdIcon from "../components/AntdIcon";
var WeiboOutlined = function WeiboOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WeiboOutlined.displayName = 'WeiboOutlined';
}
export default /*#__PURE__*/React.forwardRef(WeiboOutlined);